import { Box } from '@mui/material';
import { RenderTable } from '../../../components/ui';
import TBody from './TBody';
import TFoot from './TFoot';
import THead from './THead';
interface IProps {
  moduleData: any;
  process: any;
  setModuleData: any;
  isView: boolean;
}

const TController = ({
  moduleData,
  isView,
  process,
  setModuleData,
}: IProps) => {
  return (
    <Box>
      <RenderTable>
        <THead {...{ moduleData, isView, process, setModuleData }} />
        <TBody {...{ moduleData, isView }} />
        <TFoot {...{ moduleData, isView }} />
      </RenderTable>
    </Box>
  );
};

export default TController;
